import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import DiscountCreate from '../../components/Discount/DiscountCreate';

const DiscountCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <DiscountCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default DiscountCreatePage;